import { Button } from "@components/Button"
import { DocumentDownloadIcon } from "@assets/icons"
import PatientSideBarStat from "./PatientSideBarStat"
import DropdownButton from "./DropdownButton" // Adjust the import path as needed
import { cn } from "src/utils/common.helper"
import usePatient from "@hooks/usePatient" // Import the usePatient hook

const PatientSidebarStats = ({
  CurrentExerciseDetails,
  game,
  profileDetails,
  sideBarRef,
  setShowPerformancePdfDownload,
  showDownloadReportsButton = true,
  rootClassName,
  path,
}) => {
  const { handleGetReports } = usePatient() // Call the usePatient hook here

  const downloadReports = () => {
    setShowPerformancePdfDownload(true)
  }

  const downloadSummary = async () => {
    try {
      const data = {
        email: profileDetails?.local?.email,
        isVR: path === "vr",
      }
      const response = await handleGetReports(data)

      // Create a blob from the response data
      const blob = new Blob([response], { type: "application/zip" })
      const url = window.URL.createObjectURL(blob)

      // Create a link element and trigger the download
      const a = document.createElement("a")
      const date = new Date().toISOString().split("T")[0] // Get current date in YYYY-MM-DD format
      let filename =
        profileDetails?.local?.firstName +
        profileDetails?.local?.lastName +
        "_summary_" +
        date +
        ".zip"
      a.href = url

      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

      // console.log("Report downloaded successfully:", response)
    } catch (error) {
      console.error("Error downloading report:", error)
    }
  }

  const calculateTotalTimeSpent = (exercise) => {
    // console.log("score", exercise)
    if (!exercise || exercise?.scoreHistory?.length === 0) {
      return "-"
    }
    return exercise?.scoreHistory.reduce((accumulator, current) => {
      return current.time + accumulator
    }, 0)
  }

  const calculateAverageAccuracy = (exercise) => {
    if (!exercise || exercise?.scoreHistory?.length === 0) {
      return "-"
    }
    const sumOfAccuracies = exercise?.scoreHistory.reduce(
      (accumulator, current) => {
        return parseFloat(current.accuracy.$numberDecimal) + accumulator
      },
      0
    )
    const average = sumOfAccuracies / exercise.scoreHistory.length
    if (isNaN(average)) {
      return "-"
    }
    return average.toFixed(2)
  }

  const calculateAveragePrecision = (exercise) => {
    if (!exercise) {
      return 0
    }
    const sumOfAccuracies = exercise?.scoreHistory.reduce(
      (accumulator, current) => {
        return parseFloat(current.precision.$numberDecimal) + accumulator
      },
      0
    )
    const average = sumOfAccuracies / exercise.scoreHistory.length
    if (isNaN(average)) {
      return "-"
    }
    return average.toFixed(2)
  }
  // console.log("CurrentExerciseDetails", CurrentExerciseDetails)

  return (
    <div
      className={cn(
        "flex flex-col gap-4 md:w-full [@media(min-width:1800px)]:max-w-[324px] mx-4 md:mx-0",
        rootClassName
      )}
      ref={sideBarRef}
    >
      <div className="gap-4 grid grid-cols-patient-stats">
        <PatientSideBarStat
          title="TOTAL TIME SPENT"
          value={calculateTotalTimeSpent(CurrentExerciseDetails)}
        />
        <PatientSideBarStat 
          title="TOTAL ATTEMPTS MADE" 
          value={game? (CurrentExerciseDetails?.scoreHistory?.length) : '-'} 
        />
        <PatientSideBarStat
          title="OVERALL ACCURACY"
          value={calculateAverageAccuracy(CurrentExerciseDetails)}
        />
        <PatientSideBarStat
          title="OVERALL PRECISION"
          value={game? calculateAveragePrecision(CurrentExerciseDetails): '-'}
        />
        <PatientSideBarStat
          title="LEVEL OF EXERCISE"
          value={
            game
              ? CurrentExerciseDetails?.level ||
                profileDetails?.exercises[path]?.level
              : "-"
          }
        />
        <PatientSideBarStat 
          title="EXERCISE FINISHED" 
          value={game? (CurrentExerciseDetails?.complete) ? "Yes" : " No" : "-"} 
        />
      </div>
      {showDownloadReportsButton ? (
        <DropdownButton
          onDownloadReports={downloadReports}
          onDownloadSummary={downloadSummary}
        />
      ) : null}
    </div>
  )
}

export default PatientSidebarStats
